import React, { Component, useReducer } from 'react';
import {Table, Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import {Triangle} from 'react-loader-spinner'

  class AddNutritionalPlan extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        name: '',
        goal: '',
        description: '',
        image: null,
        categories: [
            'Build Muscle', 'Loose Weight', 'Strength And Conditioning', 'Sports Perfomance', 'KickBoxing', 'Pilates', 'Spin Class', 'Toning',
            'Rehabilitation', 'Order Adults and Geriatic Care', 'Yoga', 'Wellness Monitoring'
        ],
        audience: '',
        audience_selection: '',
        client: '',
        loading: false
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.UploadFile = (e) => {
        this.setState({[e.target.name]: e.target.files[0]})
      }

      this.AddNutritionalPlan = () => {
        this.setState({loading: true})
        var name = this.state.name
        var goal = this.state.goal
        var description = this.state.description
        var image = this.state.image

        const { cookies } = this.props;
        var data = new FormData()
        data.append('user_access_token', cookies.get('token'))
        data.append('name', name)
        data.append('goals', goal)
        data.append('description', description)
        data.append('image', image)
        var audience = ''
        if (this.state.audience == ''){
          audience = 'all'
        }else{
          audience = this.state.audience
        }
        data.append('audience', audience)
  
        axios.post(Backend_Url + 'trainerAddNutritionAndNutritionalPlan', data)
        .then((res) => {
            let result = res.data
            alert(name + ' added successfully.')
            this.setState({loading: false})
            window.location.reload()
        }).catch((error) => {
            alert('An error occured while trying to add ' + name + ', please check your data and try again.')
            this.setState({loading: false})
          })
      }

      this.AddClientToAudience = (email) => {
        var current_audience = this.state.audience

        if(current_audience == ''){
          this.setState({audience: email + ''})
        }else{
          var update = current_audience + ' ' + email
          this.setState({audience: update})
        }
        alert(email + " has been added to the stream's audience.")
        this.setState({client: ''})
      }

      this.ClientDropdown = () => {
        var client_ = this.state.client

        if(client_ == ''){
          return<div></div>
        }else{
          var clients = this.props.all_clients
      
          var matches = []
          clients.map((client, index) => {
              var email = client.email.toLowerCase()
      
              var res = email.includes(client_.toLowerCase())
              if(res == true){
                  matches.push(client)
              }
          })

          if(matches.length == 0){
            return<div>
              <br/>
              No matches found
            </div>
          }else{
            var clients_map = matches.map((client, index) => {
              return<Row style={{margin: '5px', borderBottom: '1px solid grey'}}>
                <Button onClick={() => this.AddClientToAudience(client.email)} style={{border: 'none', width: '100%', backgroundColor: 'inherit', color: 'inherit'}}>
                  {client.email}
                </Button>
              </Row>
            })
    
            return<div>
              {clients_map}
            </div>
          }
        }
      }

      this.ClientsSearchRender = () => {
        var audience_selection = this.state.audience_selection
        if(audience_selection == 'client'){
          return<div>
            Search using client's email address
            <br/>
            <Input name='client' value={this.state.client} onChange={this.HandleChange} type='text' placeholder='Client email'
              style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
            <this.ClientDropdown/>
            <br/>
            Added: {this.state.audience}
          </div>
        }else{
          return<div>

          </div>
        }
      }
    }

    componentDidMount() {
      window.scrollTo(0, 0)
    }


    render() {
      if (this.state.loading == true){
        return<div style={{backgroundImage: "url(" + Background_Image + ")", margin: '0px', minHeight: '550px'}}>
          <div style={{backgroundColor: '#ffffff', minHeight: '550px', opacity: 0.9, minHeight: '1000px'}}>
            <Container style={{textAlign: 'center', alignItems: 'center', justifyContent: 'center'}}>
              <br/>
              <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                ONFIT
              </h1>
              <br/><br/>
              <Triangle
                  color="#1FACED"
                  height={130}
                  width={130}
              />
              <h3 style={{marginTop: '50px', color: '#1FACED'}}>
                Loading...
              </h3>
              <h6 style={{marginTop: '50px'}}>
                  Taking too long to load? Check your internet connection and reload the page.
              </h6>
              <br/><br/>
            </Container>
          </div>
        </div>
      }
      return (
        <Row>
            <Helmet>
              <title>TRAINER ADD NUTRITION- ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px', marginTop: '-110px'}}>
              <br/>
              <h4 style={{}}>
                Add Nutrition
              </h4>
              <br/><br/><br/><br/>
              <Container>
                  <Row>
                      <Col sm='4'>
                        <input name='name' value={this.state.name} onChange={this.HandleChange} type='text' placeholder='Nutrition Name'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                        <br/><br/>
                      </Col>
                      <Col sm='4'>
                        <select name='goal' value={this.state.goal} onChange={this.HandleChange} type='text' placeholder='Nutrition Goal'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%', backgroundColor: 'inherit', marginTop: '7px'}}>
                            <option value=''>Select Nutrition Goal</option>
                            {this.state.categories.map((category, index) => {
                                return<option value={category}>{category}</option>
                            })}
                        </select>
                        <br/><br/><br/>
                      </Col>
                      <Col sm='4'>
                        <p style={{marginTop: '-40px'}}>Select Nutrition Image</p>
                        <Input name='image' onChange={this.UploadFile} type="file"
                        style={{backgroundColor: 'inherit', color: 'inherit'}}/>
                        <br/><br/>
                      </Col>
                  </Row>
                  <Row>
                      <Col sm='6'>
                      <br/>
                        <select name='audience_selection' value={this.state.audience_selection} onChange={this.HandleChange} type='text'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%', backgroundColor: 'inherit', marginTop: '7px'}}>
                            <option value=''>Select Plan Receipients</option>
                            <option value='all'>All users</option>
                            <option value='client'>Specific Client(s)</option>
                        </select>
                        <br/><br/>
                      </Col>
                      <Col sm='6'>
                        <this.ClientsSearchRender/>
                        <br/><br/>
                      </Col>
                  </Row>
                  <Row>
                      <Col sm='6'>
                        <br/><br/>
                        <textarea name='description' value={this.state.description} onChange={this.HandleChange} type='textarea' placeholder='Nutrition Details' rows='5'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}>
                        </textarea>
                      </Col>
                      <Col sm='6'>
                      <br/><br/><br/>
                        <Button onClick={this.AddNutritionalPlan} style={{border: 'none', backgroundColor: '#1faced', color: '#ffffff', minWidth: '40%', borderRadius: '20px'}}>
                            Add Nutritional Plan
                        </Button>
                      </Col>
                  </Row>
              </Container>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(AddNutritionalPlan);